import { IParamsTable } from '~/interfaces/IParamsTable';
import { authFetch } from '~/services/fetch';
import { IUpdateProps } from '~/interfaces/IUpdateProps';
import IWarehouse from '../interfaces/IWarehouse';

export async function getAllWarehouses() {
  const response = await authFetch({
    url: '/warehouse',
    method: 'GET',
  });
  return response.data;
}

export async function getWarehouses({
  filters = [],
  limit = 100000,
  orders = [{ field: 'name', sort: 'asc' }],
  name,
  agencyId,
  active,
}: IParamsTable & {
  readonly name?: string;
  readonly agencyId?: number;
  readonly active?: boolean;
} = {}) {
  const response = await authFetch({
    url: '/warehouse',
    method: 'POST',
    data: {
      filters,
      orders,
      limit,
      name,
      agency_id: agencyId,
      active,
    },
  });
  return response.data;
}

export async function getWarehouseById(id: IUpdateProps) {
  const response = await authFetch({
    url: `/warehouse/${id}`,
    method: 'GET',
  });
  return response.data;
}

export async function createWarehouse(data: IWarehouse) {
  const response = await authFetch({
    url: '/warehouse/store',
    method: 'POST',
    data,
  });
  return response.data;
}

export async function updateWarehouse(id: IUpdateProps, data: Partial<IWarehouse>) {
  const response = await authFetch({
    url: `/warehouse/${id}`,
    method: 'PUT',
    data,
  });
  return response.data;
}

export async function deleteWarehouse(id: IUpdateProps) {
  const response = await authFetch({
    url: `/warehouse/${id}`,
    method: 'DELETE',
  });
  return response.data;
}
